import { Component } from 'react';
import type { Button as ButtonType } from '../../../types/ChatWindow';
import type { MessageScheme } from '../../../types/configs';

class CarouselButton extends Component<
  {
    button: ButtonType;
    onClick: (...args: any[]) => void;
    scheme: MessageScheme;
  },
  unknown
> {
  handleClick = () => {
    const { onClick, button } = this.props;
    onClick(button);
  };

  render() {
    const {
      button: { title },
      scheme: { carouselButtonColor, carouselButtonTextColor },
    } = this.props;

    return (
      <button
        type='button'
        className='carousel-button'
        style={{
          color: carouselButtonTextColor,
          backgroundColor: carouselButtonColor,
        }}
        onClick={this.handleClick}>
        {title}
      </button>
    );
  }
}

export default CarouselButton;
